import { addNavMenuSection } from "@vendure/admin-ui/core";
export default [
  addNavMenuSection(
    {
      id: "seller-info",
      label: "seller-metadata.seller-metadata-group",
      items: [
        {
          icon: "info",
          id: "status",
          label: "seller-metadata.status",
          routerLink: ["/extensions", "seller-info", "seller", "status"],
        },
        {
          icon: "store",

          id: "seller-info",
          label: "seller-metadata.seller-info",
          routerLink: ["/extensions", "seller-info", "data"],
        },
        {
          icon: "library",
          id: "shopify",
          label: "Shopify",
          requiresPermission: "CreateProduct",
          routerLink: ["/extensions", "seller-info", "import", "shopify"],
        },
        {
          icon: "library",
          id: "woocommerce",
          label: "WooCommerce",
          requiresPermission: "CreateProduct",
          routerLink: ["/extensions", "seller-info", "import", "woocommerce"],
        },
        {
          icon: "library",
          id: "presta",
          label: "Presta Shop",
          requiresPermission: "CreateProduct",
          routerLink: ["/extensions", "seller-info", "import", "presta"],
        },
      ],
    },
    "sales",
  ),
];
